import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot } from "firebase/firestore";

export function useStores(env, client) {
  const [loadedStores, setLoadedStores] = useState(false);
  const [stores, setStores] = useState(null);

  useEffect(() => {
    setLoadedStores(false);
    if (!client) {
      setLoadedStores(true);
      return () => [];
    }
    let ref = collection(db, "kiosk", env, "client", client, "stores");
    
    // onSnapshot = reactivo + offline + cache
    const unsub = onSnapshot(ref, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setStores(data);
      setLoadedStores(true);
    });

    return () => unsub();
  }, [env, client]);

  return {loadedStores, stores};
}